export default "__VITE_ASSET__XCBqKztA__"